import React from "react";
import { Badge } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import HeaderMobile from "../layouts/HeaderMobile";
import blogPosts from "../data/BlogPosts";

const buildParagraphs = (post) => {
  return [
    post.summary,
    "데이터를 빠르게 읽어내기 위해서는 신뢰할 수 있는 원본과 구조화된 메타데이터가 필수입니다.",
    "구루위스퍼는 핵심 지표와 이벤트를 함께 묶어, 의사결정에 필요한 맥락을 한 화면에 제공합니다.",
    "실제 적용 시에는 기업 규모, 섹터, 발표 타이밍에 따라 해석 기준을 미세하게 조정하는 것이 중요합니다."
  ];
};

export default function BlogDetail() {
  const { id } = useParams();
  const postId = Number(id);
  const post = blogPosts.find((item) => item.id === postId);

  return (
    <React.Fragment>
      <HeaderMobile />
      <div className="main-blog p-4 p-lg-5">
        <div className="blog-detail">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
            <div className="blog-meta">
              <Badge bg="light" text="dark">블로그</Badge>
              {post ? (
                <span>{post.category}</span>
              ) : null}
            </div>
            <Link to="/intro/aboutus" className="btn btn-white">목록으로</Link>
          </div>

          {!post ? (
            <div className="blog-empty">
              <h4 className="mb-2">글을 찾을 수 없습니다.</h4>
              <p className="text-secondary mb-0">요청하신 글 번호를 확인해주세요.</p>
            </div>
          ) : (
            <React.Fragment>
              <p className="blog-detail-date">{post.date} · {post.readingTime}분 읽기</p>
              <h1 className="blog-detail-title">{post.title}</h1>
              <p className="blog-detail-summary">{post.summary}</p>

              {post.image ? (
                <div
                  className="blog-detail-hero"
                  role="img"
                  aria-label={post.title}
                  style={{ backgroundImage: `url(${post.image})` }}
                />
              ) : null}

              <div className="blog-detail-body">
                {buildParagraphs(post).map((paragraph, index) => (
                  <p key={`${post.id}-${index}`}>{paragraph}</p>
                ))}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
